import React, { useState } from 'react';
import { LayoutDashboard, Gavel, FileCheck, Users, FileText, TrendingUp, ChevronDown, ChevronRight, MoreVertical, Download, Eye, Clock, Check, X } from 'lucide-react';
import { DashboardLayout } from '../components/DashboardLayout';
export function AuthorityDashboardPage() {
  const [expandedCompliance, setExpandedCompliance] = useState<string | null>(null);
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/authority'
  }, {
    label: 'Auctions',
    icon: Gavel,
    path: '/authority/auctions',
    badge: '3 Active'
  }, {
    label: 'Compliance',
    icon: FileCheck,
    path: '/authority/compliance'
  }, {
    label: 'Public Listings',
    icon: Users,
    path: '/authority/listings'
  }, {
    label: 'Reports',
    icon: FileText,
    path: '/authority/reports'
  }];
  return <DashboardLayout title="Authority Portal" personaLabel="GOVT AUTHORITY" personaColor="bg-orange-100 text-orange-800 border-orange-200" navItems={navItems} userInitials="GA" data-id="element-2855">
      <h1 className="text-2xl font-bold mb-2" data-id="element-2856">Welcome, District Collector</h1>
      <p className="text-gray-500 mb-8 font-mono text-sm" data-id="element-2857">
        Pune Metropolitan Region Development Authority (PMRDA)
      </p>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-2858">
        {[{
        label: 'Active Auctions',
        value: '12',
        sub: 'Closing soon: 3'
      }, {
        label: 'Land Revenue',
        value: '₹42.5Cr',
        sub: 'FY 2024-25'
      }, {
        label: 'Pending Approvals',
        value: '28',
        sub: 'Avg time: 4 days'
      }, {
        label: 'Registered Plots',
        value: '1,240',
        sub: '+12% vs last month'
      }].map((stat, i) => <div key={i} className="bg-white border border-gray-300 p-6" data-id="element-2859">
            <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-2860">
              {stat.label}
            </h3>
            <div className="flex items-baseline gap-2" data-id="element-2861">
              <span className="text-3xl font-bold" data-id="element-2862">{stat.value}</span>
            </div>
            <span className="text-xs font-mono text-gray-400 mt-1 block" data-id="element-2863">
              {stat.sub}
            </span>
          </div>)}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8" data-id="element-2864">
        {/* Auction Calendar with Quick Actions */}
        <div className="bg-white border border-gray-300 p-6" data-id="element-2865">
          <div className="flex justify-between items-center mb-6" data-id="element-2866">
            <h3 className="font-bold text-lg flex items-center gap-2" data-id="element-2867">
              <Gavel className="w-5 h-5" data-id="element-2868" /> Upcoming Auctions
            </h3>
            <button className="text-sm font-bold text-blue-600 hover:underline" data-id="element-2869">
              View All
            </button>
          </div>
          <div className="space-y-4" data-id="element-2870">
            {[{
            id: 'AUC-2024-001',
            loc: 'Hinjewadi Phase 3',
            date: 'Oct 25, 2024',
            base: '₹1.2 Cr'
          }, {
            id: 'AUC-2024-002',
            loc: 'Wagholi Commercial',
            date: 'Oct 28, 2024',
            base: '₹3.5 Cr'
          }, {
            id: 'AUC-2024-003',
            loc: 'Baner Residential',
            date: 'Nov 02, 2024',
            base: '₹85 L'
          }].map((auc, i) => <div key={i} className="p-4 border border-dashed border-gray-200 bg-gray-50 hover:bg-white hover:border-gray-300 transition-colors group" data-id="element-2871">
                <div className="flex items-center justify-between mb-3" data-id="element-2872">
                  <div data-id="element-2873">
                    <div className="font-bold text-sm" data-id="element-2874">{auc.loc}</div>
                    <div className="text-xs font-mono text-gray-500" data-id="element-2875">
                      {auc.id}
                    </div>
                  </div>
                  <div className="text-right" data-id="element-2876">
                    <div className="font-bold text-sm" data-id="element-2877">{auc.base}</div>
                    <div className="text-xs font-mono text-gray-500" data-id="element-2878">
                      {auc.date}
                    </div>
                  </div>
                </div>
                {/* Quick Actions */}
                <div className="flex gap-2 pt-3 border-t border-gray-200 opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-2879">
                  <button className="flex-1 py-1.5 text-xs font-bold border border-gray-300 bg-white hover:bg-gray-50 flex items-center justify-center gap-1" data-id="element-2880">
                    <Eye className="w-3 h-3" data-id="element-2881" /> Details
                  </button>
                  <button className="flex-1 py-1.5 text-xs font-bold border border-gray-300 bg-white hover:bg-gray-50 flex items-center justify-center gap-1" data-id="element-2882">
                    <Clock className="w-3 h-3" data-id="element-2883" /> Extend
                  </button>
                  <button className="flex-1 py-1.5 text-xs font-bold border border-gray-300 bg-white hover:bg-gray-50 flex items-center justify-center gap-1" data-id="element-2884">
                    <Download className="w-3 h-3" data-id="element-2885" /> Bids
                  </button>
                </div>
              </div>)}
          </div>
        </div>

        {/* Interactive Compliance Overview */}
        <div className="bg-white border border-gray-300 p-6" data-id="element-2886">
          <div className="flex justify-between items-center mb-6" data-id="element-2887">
            <h3 className="font-bold text-lg flex items-center gap-2" data-id="element-2888">
              <FileCheck className="w-5 h-5" data-id="element-2889" /> Compliance Status
            </h3>
            <button className="text-sm font-bold text-blue-600 hover:underline" data-id="element-2890">
              View Report
            </button>
          </div>
          <div className="space-y-4" data-id="element-2891">
            {[{
            label: 'RERA Registration',
            value: 92,
            color: 'bg-green-500',
            id: 'rera'
          }, {
            label: 'NA Conversion',
            value: 78,
            color: 'bg-yellow-500',
            id: 'na'
          }, {
            label: 'Tax Payments',
            value: 65,
            color: 'bg-orange-500',
            id: 'tax'
          }].map(item => <div key={item.id} className="border border-gray-100 rounded p-3 hover:border-gray-300 cursor-pointer" onClick={() => setExpandedCompliance(expandedCompliance === item.id ? null : item.id)} data-id="element-2892">
                <div className="flex justify-between items-center mb-2" data-id="element-2893">
                  <div className="flex items-center gap-2" data-id="element-2894">
                    {expandedCompliance === item.id ? <ChevronDown className="w-4 h-4" data-id="element-2895" /> : <ChevronRight className="w-4 h-4" data-id="element-2896" />}
                    <span className="font-medium text-sm" data-id="element-2897">{item.label}</span>
                  </div>
                  <span className="font-mono font-bold text-sm" data-id="element-2898">
                    {item.value}%
                  </span>
                </div>
                <div className="h-2 bg-gray-100 rounded-full overflow-hidden mb-2" data-id="element-2899">
                  <div className={`h-full ${item.color}`} style={{
                width: `${item.value}%`
              }} data-id="element-2900"></div>
                </div>

                {/* Drill-down Details */}
                {expandedCompliance === item.id && <div className="mt-3 pt-3 border-t border-dashed border-gray-200 text-xs animate-in slide-in-from-top-2" data-id="element-2901">
                    <div className="grid grid-cols-2 gap-4 mb-2" data-id="element-2902">
                      <div data-id="element-2903">
                        <span className="text-gray-500 block" data-id="element-2904">
                          Compliant Zones
                        </span>
                        <span className="font-bold text-green-600" data-id="element-2905">
                          Sector 1, 4, 7
                        </span>
                      </div>
                      <div data-id="element-2906">
                        <span className="text-gray-500 block" data-id="element-2907">
                          Flagged Zones
                        </span>
                        <span className="font-bold text-red-600" data-id="element-2908">
                          Sector 2, 9
                        </span>
                      </div>
                    </div>
                    <button className="text-blue-600 font-bold hover:underline" data-id="element-2909">
                      View Violation Report →
                    </button>
                  </div>}
              </div>)}
          </div>

          <div className="mt-6 p-4 bg-red-50 border border-red-100 flex items-start gap-3" data-id="element-2910">
            <div className="p-1 bg-red-100 rounded" data-id="element-2911">
              <TrendingUp className="w-4 h-4 text-red-600" data-id="element-2912" />
            </div>
            <div data-id="element-2913">
              <div className="font-bold text-sm text-red-900" data-id="element-2914">
                Violation Alert
              </div>
              <p className="text-xs text-red-700 mt-1" data-id="element-2915">
                3 developers flagged for zone violations in Sector 4. Immediate
                review required.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Public Listing Approvals Queue (New Section) */}
      <div className="bg-white border border-gray-300 p-6" data-id="element-2916">
        <div className="flex justify-between items-center mb-6" data-id="element-2917">
          <h3 className="font-bold text-lg flex items-center gap-2" data-id="element-2918">
            <Users className="w-5 h-5" data-id="element-2919" /> Public Listing Approvals
          </h3>
          <span className="bg-orange-100 text-orange-800 text-xs font-bold px-2 py-1 rounded" data-id="element-2920">
            5 Pending
          </span>
        </div>

        <div className="overflow-x-auto" data-id="element-2921">
          <table className="w-full text-left text-sm" data-id="element-2922">
            <thead className="bg-gray-50 border-b border-gray-200 font-mono text-xs uppercase text-gray-500" data-id="element-2923">
              <tr data-id="element-2924">
                <th className="p-3" data-id="element-2925">Listing</th>
                <th className="p-3" data-id="element-2926">Applicant</th>
                <th className="p-3" data-id="element-2927">Zone</th>
                <th className="p-3" data-id="element-2928">Documents</th>
                <th className="p-3 text-right" data-id="element-2929">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2930">
              {[{
              title: 'Plot 44, Wagholi',
              user: 'Amit S.',
              zone: 'R-Zone',
              docs: 'Verified'
            }, {
              title: 'Survey 12, Baner',
              user: 'Priya M.',
              zone: 'Comm.',
              docs: 'Pending'
            }].map((item, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-2931">
                  <td className="p-3 font-bold" data-id="element-2932">{item.title}</td>
                  <td className="p-3" data-id="element-2933">{item.user}</td>
                  <td className="p-3 font-mono text-xs" data-id="element-2934">{item.zone}</td>
                  <td className="p-3" data-id="element-2935">
                    <span className={`text-xs px-2 py-1 rounded border ${item.docs === 'Verified' ? 'bg-green-50 border-green-200 text-green-700' : 'bg-yellow-50 border-yellow-200 text-yellow-700'}`} data-id="element-2936">
                      {item.docs}
                    </span>
                  </td>
                  <td className="p-3 text-right" data-id="element-2937">
                    <div className="flex justify-end gap-2" data-id="element-2938">
                      <button className="p-1.5 border border-green-200 bg-green-50 text-green-700 hover:bg-green-100 rounded" data-id="element-2939">
                        <Check className="w-4 h-4" data-id="element-2940" />
                      </button>
                      <button className="p-1.5 border border-red-200 bg-red-50 text-red-700 hover:bg-red-100 rounded" data-id="element-2941">
                        <X className="w-4 h-4" data-id="element-2942" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>;
}